import { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoutes";
import NavBar from "../components/layouts/navBar/navBar";
import { Cookie } from "../hooks/useStorage";
import Cookies from "js-cookie";
import ProtectedReportRoute from "./protectedReportRoutes";

const Dashboard = lazy(() => import("../pages/Dashboard/dashboard"));
const UserDashBoard = lazy(
  () => import("../pages/userManagement/userDashboard")
);
const CreateUser = lazy(() => import("../pages/userManagement/createUser"));
const EditUser = lazy(() => import("../pages/userManagement/editUser"));
const ViewUser = lazy(() => import("../pages/userManagement/viewUser"));
const UserList = lazy(() => import("../pages/userManagement/userList"));
const UserRoles = lazy(() => import("../pages/userManagement/Roles/roles"));
const Permissions = lazy(
  () => import("../pages/userManagement/permissions/permissions")
);

const Enquiries = lazy(() => import("../pages/Enquiries/enquiries"));
const InquiryForm = lazy(() => import("../pages/Enquiries/inquiryForm"));
const EnquiryTabList = lazy(() => import("../pages/Enquiries/enquiryTabList"));

const EventPlanning = lazy(
  () => import("../pages/EventPlanning/eventPlanning")
);
const MainEventTabPage = lazy(
  () => import("../pages/EventPlanning/mainTabPage")
);

const VenueDashBoard = lazy(
  () => import("../pages/venueManagement/venueDashBoard")
);
const AddVenueTable = lazy(
  () => import("../pages/venueManagement/addVenueTable")
);
const VenueContactTable = lazy(
  () => import("../pages/venueManagement/venueContactTable")
);
const EditVenue = lazy(() => import("../pages/venueManagement/editVenue"));
const ViewVenue = lazy(() => import("../pages/venueManagement/viewVenue"));

const SupplierDashBoard = lazy(
  () => import("../pages/supplierManagement/supplierDashBoard")
);
const AddSupplierTable = lazy(
  () => import("../pages/supplierManagement/addSupplierTable")
);
const AddContactTable = lazy(
  () => import("../pages/supplierManagement/addContactTable")
);
const EditSupplier = lazy(
  () => import("../pages/supplierManagement/editSupplier")
);
const ViewSupplier = lazy(
  () => import("../pages/supplierManagement/viewSupplier")
);

const CustomerDashBoard = lazy(
  () => import("../pages/CustomerManagement/customerDashboard")
);
const CustomerOverView = lazy(
  () => import("../pages/CustomerManagement/customerOverView/CustomerOverView")
);

const Reports = lazy(() => import("../pages/Reports/reports"));
const MailTemplates = lazy(() => import("../pages/MailTemplates/mailTemplates"));
const ViewEventStatus = lazy(() => import("../pages/Reports/eventStatusReports/ViewEventStatus/viewEventStatus"));
const ViewSalesPerformance = lazy(() => import("../pages/Reports/salesPerformanceTracking/ViewSalesPerformance/viewSalesPerformance"));
const Payment = lazy(() => import("../pages/Payment/payment"));
const FormDocuments = lazy(
  () => import("../pages/FormDocuments/formDocuments")
);
const EventContractForms = lazy(
  () => import("../pages/FormDocuments/eventContractForms")
);
const Settings = lazy(() => import("../pages/Settings/settings"));
const CustomTextEditor = lazy(
  () => import("../components/common/commonTextEditor/textEditor")
);

const token = Cookies.get()?.access_token || null;
export const privateRoutes = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <NavBar />
      </ProtectedRoute>
    ),
    children: [
      { path: "dashboard", element: <Dashboard /> },
      {
        path: "user-list",
        element: <UserDashBoard />,
        children: [
          { path: "create-user", element: <CreateUser /> },
          { path: "edit-user", element: <EditUser /> },
          { path: "view-user", element: <ViewUser /> },
          { path: "user-list", element: <UserList /> },
          { path: "roles-list", element: <UserRoles /> },
          { path: "permissions-list", element: <Permissions /> },
        ],
      },
      {
        path: "enquiries-list",
        element: <Enquiries />,
        children: [{ path: "enquiry", element: <EnquiryTabList /> }],
      },
      { path: "enquiry-form", element: <InquiryForm /> },
      {
        path: "event-list",
        element: <EventPlanning />,
        children: [{ path: "Clients", element: <MainEventTabPage /> }],
      },
      {
        path: "venue-list",
        element: <VenueDashBoard />,
        children: [
          { path: "add-contact-venue", element: <VenueContactTable /> },
          { path: "add-venue-table", element: <AddVenueTable /> },
          { path: "view-venue", element: <ViewVenue /> },
          { path: "edit-venue", element: <EditVenue /> },
        ],
      },
      {
        path: "supplier-list",
        element: <SupplierDashBoard />,
        children: [
          { path: "add-supplier-table", element: <AddSupplierTable /> },
          { path: "add-contact-table", element: <AddContactTable /> },
          { path: "view-supplier", element: <ViewSupplier /> },
          { path: "edit-supplier", element: <EditSupplier /> },
        ],
      },
      {
        path: "/customer-list",
        children: [
          {
            index: true,
            element: <CustomerDashBoard />,
          },
          {
            path: "view-customer",
            element: <CustomerOverView />,
          },
        ],
      },
      {
        path: "mail-templates",
        element: <MailTemplates />,
      },
      {
        path: "report-management",
        element: <Reports />,
        children: [
          {
            path: "event-status",
            element: (
              <ProtectedReportRoute 
                reportType="Event Status Report" 
                sectionId="event-status-report"
              >
                <ViewEventStatus />
              </ProtectedReportRoute>
            ),
          },
          {
            path: "sales-performance",
            element: (
              <ProtectedReportRoute 
                reportType="Sales Performance Tracking" 
                sectionId="sales-performance-tracking"
              >
                <ViewSalesPerformance />
              </ProtectedReportRoute>
            ),
          },
        ],
      },
      { path: "payments", element: <Payment /> },
      { path: "form-documents", element: <FormDocuments /> },
      { path: "form-documents/:eventId", element: <EventContractForms /> },
      { path: "settings", element: <Settings /> },
      { path: "textEditor", element: <CustomTextEditor /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to={token ? "/dashboard" : "/"} replace />,
  },
];
